var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
  'container',
  'ignore',
  { 'has-header': _vm.hasHeader },
  { 'has-footer': _vm.$slots.footer },
  { 'has-tabbar': _vm.isIndex },
]},[(_vm.hasHeader)?_c('header',{staticClass:"page-header",staticStyle:{"z-index":"12"}},[_vm._t("header")],2):_vm._e(),_c('main',{staticClass:"page-body"},[_vm._t("default")],2),(_vm.$slots.footer)?_c('footer',{staticClass:"page-footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }